import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

function HizmetDetay({ baslik, aciklama, resim, seoMetni, icon, stat1, stat2 }) {
  
  // --- AOS VE DİNAMİK BAŞLIK BAŞLATMA ---
  useEffect(() => {
    // Sayfa başlığını gelen prop'a göre zorla günceller
    document.title = `${baslik} | Ankara Merkez Teknik`;

    window.scrollTo(0, 0); // Sayfa açılınca en üste atar
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      offset: 100,
    });
  }, [baslik]); // Başlık değişirse (sayfa arası geçişte) tekrar tetiklenir

  return (
    <div className="service-detail-master">
      <Helmet>
        <title>{baslik} | Ankara Merkez Teknik</title>
        <meta name="description" content={`${baslik} alanında Ankara'nın tüm ilçelerine orijinal yedek parça garantili teknik servis.`} />
      </Helmet>

      {/* --- 1. SİNEMATİK HERO (ANA BAŞLIK) --- */}
      <section 
        className="about-cinematic-hero" 
        data-aos="fade-in"
        style={{ 
          backgroundImage: `url(${resim})`, 
          backgroundSize: 'cover', 
          backgroundPosition: 'center' 
        }}
      >
        <div className="cinematic-overlay"></div>
        <div className="cinematic-content" data-aos="zoom-in" data-aos-delay="200">
          <span className="sub-title-elegant">{icon} PROFESYONEL HİZMET</span>
          <h1>{baslik}</h1>
        </div>
      </section>

      {/* --- 2. GÜVEN ŞERİDİ (TRUST BAR) --- */}
      <div className="trust-bar-wrapper" data-aos="fade-up" data-aos-delay="400">
        <div className="trust-bar-container">
          <div className="trust-item">
            <span className="t-icon">🏆</span>
            <div className="t-text"><strong>{stat1}</strong><span>Uzman Kadro</span></div>
          </div>
          <div className="trust-item divider"></div>
          <div className="trust-item">
            <span className="t-icon">🛡️</span>
            <div className="t-text"><strong>1 Yıl Garanti</strong><span>İşçilik ve Parça</span></div>
          </div>
          <div className="trust-item divider"></div>
          <div className="trust-item">
            <span className="t-icon">⏱️</span>
            <div className="t-text"><strong>{stat2}</strong><span>Hızlı Servis</span></div>
          </div>
          <div className="trust-item divider"></div>
          <div className="trust-item">
            <span className="t-icon">📍</span>
            <div className="t-text"><strong>Ankara</strong><span>Gezici Servis</span></div>
          </div>
        </div>
      </div>

      {/* --- 3. YENİ NESİL EDİTORYAL SEO İÇERİK ALANI --- */}
      <section className="editorial-content-section">
        <div className="editorial-container">
          
          <div className="editorial-header" data-aos="fade-up">
            <h3>Garantili Onarım ve Yedek Parça Desteği</h3>
            <p className="editorial-lead">{aciklama}</p>
          </div>
          
          {/* SEO Grid Alanı (Sayfalardan gelen kartlar buraya düşer) */}
          <div className="editorial-seo-grid">
            {seoMetni}
          </div>
          
          <div className="editorial-checklist" data-aos="fade-up">
            <div className="check-badge"><span>✓</span> Aynı Gün Tamir</div>
            <div className="check-badge"><span>✓</span> Orijinal Parça</div>
            <div className="check-badge"><span>✓</span> Uzman Ustalar</div>
            <div className="check-badge"><span>✓</span> Şeffaf Fiyat</div>
          </div>
          
          <div className="editorial-action" data-aos="zoom-in">
            <a href="tel:03125810881" className="btn-primary">Hemen Arıza Kaydı Oluştur</a>
          </div>

        </div>
      </section>
    </div>
  );
}

export default HizmetDetay;